module.exports = __webpack_public_path__ + "static/media/Voyager-RE-4100.038ccba8.jpg";